import cloneDeep from 'lodash/cloneDeep';

const defaultOdooFormState = {
  formType: null,
  formId: null,
  formPage: null,
  form: null,
  isFetching: false,
  isSaving: false,
};

const odooFormReducer = (state = defaultOdooFormState, action) => {
  // We use a deep clone so that we aren't mutating the original state
  let out = cloneDeep(state);

  switch (action.type) {
    case 'ODOOFORM_LOAD_START':
      return {
        ...state,
        formType: action.formType,
        formId: action.formId,
        formPage: typeof action.formPage !== 'undefined' ? action.formPage : null,
        form: null,
        isFetching: true,
      };
    case 'ODOOFORM_LOAD_END':
      return {
        ...state,
        isFetching: false,
      };
    case 'ODOOFORM_SAVE_START':
      return {
        ...state,
        isSaving: true,
        formType: action.formType,
        formId: action.formId,
        formPage: typeof action.formPage !== 'undefined' ? action.formPage : null,
      };
    case 'ODOOFORM_SAVE_END':
      return {
        ...state,
        isSaving: false,
      };
    // Set the data for the form page to show
    case 'ODOOFORM_SET_FORM':
      return {
        ...state,
        formType: action.formType,
        formId: action.formId,
        formPage: action.formPage,
        form: action.form,
      };
    // Change a field's details fetched from an API call
    case 'ODOOFORM_SET_FIELD_DETAILS':
      // NOTE: 'out' is set above the switch statement
      // Avoid attempting to set field details if we don't have the field yet
      if (typeof out.form === 'undefined' || typeof out.form.page === 'undefined' || typeof out.form.page.sections === 'undefined') {
        return out;
      }
      // Find specified fieldName and set new details
      for (let i = 0, ii = out.form.page.sections.length; i < ii; i++) {
        let fieldGroups = out.form.page.sections[i].fieldGroups;
        for (let j = 0, jj = fieldGroups.length; j < jj; j++) {
          let fields = fieldGroups[j].fields;
          for (let k = 0, kk = fields.length; k < kk; k++) {
            // Is this the field we want to change?
            if (fields[k].fieldName !== action.fieldName) {
              continue;
            }
            // we've found the field in question; set the hasManyFieldDetails
            // for the row, so the HasManyFieldGroup component can render it
            // differently from the stock value, and mark it is no longer dirty
            if (action.rowIndex !== null) {
              if (typeof out.form.page.sections[i].fieldGroups[j].fields[k].hasManyFieldDetails === 'undefined') {
                out.form.page.sections[i].fieldGroups[j].fields[k].hasManyFieldDetails = [];
              }
              out.form.page.sections[i].fieldGroups[j].fields[k].hasManyFieldDetails[action.rowIndex] = action.fieldDetails;
              if (typeof out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating === 'undefined') {
                out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating = [];
              }
              out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating[action.rowIndex] = false;
              if (typeof out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate === 'undefined') {
                out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate = [];
              }
              out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate[action.rowIndex] = false;
            } else {
              out.form.page.sections[i].fieldGroups[j].fields[k].fieldDetails = action.fieldDetails;
              out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating = false;
              out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate = false;
            }
            // Exit early - we found our field, we don't need to keep looping
            return out;
          }
        }
      }
      // Fallback in case we named a field that doesn't exist on this page...
      return out;
    case 'ODOOFORM_MARK_FIELDDETAILS_DIRTY':
      // NOTE: 'out' is set above the switch statement
      // Avoid attempting to set field details if we don't have the field yet
      if (typeof out.form === 'undefined' || typeof out.form.page === 'undefined' || typeof out.form.page.sections === 'undefined') {
        return out;
      }
      for (let i = 0, ii = out.form.page.sections.length; i < ii; i++) {
        let fieldGroups = out.form.page.sections[i].fieldGroups;
        for (let j = 0, jj = fieldGroups.length; j < jj; j++) {
          let fields = fieldGroups[j].fields;
          for (let k = 0, kk = fields.length; k < kk; k++) {
            // Is this the field we want to change?
            if (fields[k].fieldName !== action.fieldName) {
              continue;
            }
            // If we specified a row, isUpdating is an array
            if (action.hasManyRow !== null) {
              if (typeof out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating === 'undefined') {
                out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating = [];
              }
              out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating[action.hasManyRow] = false;
              if (typeof out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate === 'undefined') {
                out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate = [];
              }
              out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate[action.hasManyRow] = true;
            } else {
              out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating = false;
              out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate = true;
            }
            // Exit early - we found our field, we don't need to keep looping
            return out;
          }
        }
      }

      return out;
    case 'ODOOFORM_MARK_FIELDDETAILS_UPDATING':
      // NOTE: 'out' is set above the switch statement
      // Avoid attempting to set field details if we don't have the field yet
      if (typeof out.form === 'undefined' || typeof out.form.page === 'undefined' || typeof out.form.page.sections === 'undefined') {
        return out;
      }
      for (let i = 0, ii = out.form.page.sections.length; i < ii; i++) {
        let fieldGroups = out.form.page.sections[i].fieldGroups;
        for (let j = 0, jj = fieldGroups.length; j < jj; j++) {
          let fields = fieldGroups[j].fields;
          for (let k = 0, kk = fields.length; k < kk; k++) {
            // Is this the field we want to change?
            if (fields[k].fieldName !== action.fieldName) {
              continue;
            }
            // If we specified a row, isUpdating is an array
            if (action.hasManyRow !== null) {
              if (typeof out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating === 'undefined') {
                out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating = [];
              }
              out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating[action.hasManyRow] = true;
              if (typeof out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate === 'undefined') {
                out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate = [];
              }
              out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate[action.hasManyRow] = false;
            } else {
              out.form.page.sections[i].fieldGroups[j].fields[k].isUpdating = true;
              out.form.page.sections[i].fieldGroups[j].fields[k].shouldUpdate = false;
            }
            // Exit early - we found our field, we don't need to keep looping
            return out;
          }
        }
      }

      return out;
    case 'SEARCH_PEERS':
      return {
        ...state,
        peers: action.peers,
        searching: false,
      };
    case 'SEARCH_PEERS_START':
      return {
        ...state,
        searching: true,
      };
    case 'SEARCH_PEERS_ERROR':
      return {
        ...state,
        peers: null,
        searching: false,
      };
    default:
      return state;
  }
};

export default odooFormReducer;
